enum ServiceTypes {
  REQUEST_INSTANCE_REQUEST = 'service/REQUEST_INSTANCE_REQUEST',
  REQUEST_INSTANCE_SUCCESS = 'service/REQUEST_INSTANCE_SUCCESS',
  REQUEST_INSTANCE_FAILURE = 'service/REQUEST_INSTANCE_FAILURE',
  REQUEST_LIST_REQUEST = 'service/REQUEST_LIST_REQUEST',
  REQUEST_LIST_SUCCESS = 'service/REQUEST_LIST_SUCCESS',
  REQUEST_LIST_FAILURE = 'service/REQUEST_LIST_FAILURE',
  RESET_LIST = 'service/RESET_LIST',
  SAVE_INSTANCE_REQUEST = 'service/SAVE_INSTANCE_REQUEST',
  SAVE_INSTANCE_SUCCESS = 'service/SAVE_INSTANCE_SUCCESS',
  SAVE_INSTANCE_FAILURE = 'service/SAVE_INSTANCE_FAILURE',
  SCREEN_DETAILS_REQUEST = 'service/SCREEN_DETAILS_REQUEST',
  SCREEN_DETAILS_SUCCESS = 'service/SCREEN_DETAILS_SUCCESS',
  SCREEN_DETAILS_FAILURE = 'service/SCREEN_DETAILS_FAILURE',
  DELETE_INSTANCE_REQUEST = 'service/DELETE_INSTANCE_REQUEST',
  DELETE_INSTANCE_SUCCESS = 'service/DELETE_INSTANCE_SUCCESS',
  DELETE_INSTANCE_FAILURE = 'service/DELETE_INSTANCE_FAILURE',
  REQUEST_DATA_IN_PROGRESS = 'service/REQUEST_DATA_IN_PROGRESS',
  REQUEST_DATA_COMPLETE = 'service/REQUEST_DATA_COMPLETE',
  DISMISS_SYSTEM_ALERT = 'service/DISMISS_SYSTEM_ALERT',
  DISMISS_CONFIRMATION_PROMPT = 'service/DISMISS_CONFIRMATION_PROMPT',
  FORM_CONFIRM_MESSAGE = 'service/FORM_CONFIRM_MESSAGE',

  GENERIC_ALERT = 'service/GENERIC_ALERT',
  GENERIC_REQUEST = 'service/GENERIC_REQUEST',
  GENERIC_SUCCESS = 'service/GENERIC_SUCCESS',
  GENERIC_FAILURE = 'service/GENERIC_FAILURE',
  PERFORM_ACTION_REQUEST = 'service/PERFORM_ACTION_REQUEST',
  PERFORM_ACTION_SUCCESS = 'service/PERFORM_ACTION_SUCCESS',
  SAVE_MENU_REQUEST = 'service/SAVE-MENU_REQUEST',
  SAVE_MENU_SUCCESS = 'service/SAVE-MENU-SUCCESS',
  SET_API_CODE = 'service/SET_API_CODE',
  ACTION_ALERT = 'service/ACTION_ALERT',
  CUSTOM_ALERT = 'service/CUSTOM_ALERT',
  SWITCH_COMPANY_SUCCESS = 'service/SWITCH_COMPANY_SUCCESS',
}

export default ServiceTypes;
